import { useContext, useEffect, useState } from "react";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState, Tier } from "../../../../../models/SKArtifact";
import { capitalizeFirstLetter } from "../../../../../utils/stringFunctions";
import { useAuth } from "../../../../../context/AuthContext";
import { Tier as ChannelTier } from "../../../../../models/SKChannel";

interface PublishingTiersProps {
  index: number;
}

export const PublishingTier = ({ index }: PublishingTiersProps) => {
  const context = useAuth();

  const { contentData, updateContentData } = useContext(CreateArtifactContext);
  const [editable, setEditable] = useState<boolean>(true);

  useEffect(() => {
    const channelSubscriptionStatus = context?.myChannel?.subscriptionStatus;
    if (contentData.status === ContentState.DRAFT && channelSubscriptionStatus === ChannelTier.freeNpaid) {
      setEditable(true);
    } else {
      setEditable(false);
    }
  }, [contentData]);

  useEffect(() => {
    const channelSubscriptionStatus = context?.myChannel?.subscriptionStatus;
    if (channelSubscriptionStatus === ChannelTier.paid && contentData.tier !== Tier.subscription) {
      updateContentData({ tier: Tier.subscription });
    }
  }, [contentData.tier, contentData.tier]);

  const getImage = (tier: string) => {
    if (contentData.tier === tier) {
      return editable ? "/icons/CheckFilled.png" : "/icons/checkeditem.png";
    }
    return "/icons/CheckInactive.png";
  };

  return (
    <div>
      <div className="flex flex-col w-[480px]">
        <div className="flex items-center">
          {index && <span className="content_count">{index}</span>}
          <span className="content_title">Choose the Publishing Tier</span>
        </div>

        <div className="notes-class-wo-btm-space ">You can change the tier of this content anytime after publishing.</div>

        {Object.values(Tier).map((tier, idx) => (
          <div
            tabIndex={0}
            onClick={() => {
              if (editable) {
                updateContentData({ ...contentData, tier });
              }
            }}
            key={idx}
            className="border-skseparatorgray max-w-[480px] border-b-[1px] pt-[15px] pb-[15px] flex flex-row w-full items-center cursor-pointer"
          >
            <div>
              <img src={getImage(tier)} className="object-contain w-[22px] h-[22px] min-w-5" alt={`Tier status for ${tier}`} />
            </div>

            <span className="radio-button-choose">{capitalizeFirstLetter(tier)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
